document.addEventListener('click', function (event) {
  var opener = event.target.closest('[data-size-guide-open]');
  if (opener) {
    var wrapper = opener.closest('.product-form__input') || opener.parentElement;
    var dialog = wrapper ? wrapper.querySelector('[data-size-guide-dialog]') : null;
    if (!dialog) {
      dialog = document.querySelector('[data-size-guide-dialog]');
    }
    if (dialog && typeof dialog.showModal === 'function') {
      dialog.showModal();
    }
    return;
  }

  var closer = event.target.closest('[data-size-guide-close]');
  if (closer) {
    var dlg = closer.closest('dialog');
    if (dlg) dlg.close();
    return;
  }

  if (event.target.tagName === 'DIALOG' && event.target.hasAttribute('data-size-guide-dialog')) {
    var rect = event.target.getBoundingClientRect();
    var clickedInside =
      rect.top <= event.clientY &&
      event.clientY <= rect.top + rect.height &&
      rect.left <= event.clientX &&
      event.clientX <= rect.left + rect.width;
    if (!clickedInside) {
      event.target.close();
    }
  }
});
